import React, {useState} from 'react';

import cs from 'classnames';
import styled from 'styled-components';

// Styled components
export const ColorButton = styled.button.attrs({className: 'rounded'})<{
  isSelected: boolean;
  bgColor: string;
}>`
  width: 30px;
  height: 30px;
  border: ${(props) =>
    props.isSelected ? '2px solid black' : '1px solid #ddd'};
  margin: 0 5px;
  cursor: pointer;
  outline: none;
  background-color: ${(props) => props.bgColor};
`;

const CustomColorInput = styled.input`
  margin-right: 10px;
`;

// Color palette
const COLORS = [
  '#D9E3F0',
  '#F47373',
  '#697689',
  '#37D67A',
  '#2CCCE4',
  '#555555',
  '#dce775',
  '#ff8a65',
  '#ba68c8',
];

type Props = {
  initialColor: string;
  onSubmit: (color: string) => unknown;
  colors?: Array<string>;
  error?: Array<string>;
};

export const ColorPicker = ({
  initialColor = '#D9E3F0',
  onSubmit,
  colors = COLORS,
  error,
}: Props) => {
  const [selectedColor, setSelectedColor] = useState(initialColor);

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    onSubmit(color);
  };

  const handleCustomColorInput = (e) => {
    setSelectedColor(e.target.value);
    onSubmit(e.target.value);
  };

  return (
    <div>
      <div className="d-flex mb-2">
        {colors.map((color) => (
          <ColorButton
            key={color}
            onClick={(e) => {
              e.preventDefault();
              handleColorSelect(color);
            }}
            bgColor={color}
            isSelected={selectedColor === color}
            aria-label={`Select color ${color}`}
          />
        ))}
      </div>
      <CustomColorInput
        type="text"
        value={selectedColor}
        onChange={handleCustomColorInput}
        placeholder="Enter hex value"
        className={cs('form-control', {'is-invalid': error != null})}
      />
      {error != null ? (
        <div className="invalid-feedback">{error.join(', ')}</div>
      ) : null}
    </div>
  );
};
